import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import AbstractVisual from '../AbstractVisual/AbstractVisual'
import './articleCta.scss'

/**
 * Conversion block closing every article.
 *
 * Articles are the site's main source of search traffic, and until now they
 * ended with nothing but a link to the next one — a reader who finished
 * convinced had no way to act on it. Now they get two ways through: talk to a
 * person, or self-serve the readiness check.
 */
const ArticleCta = () => {
  const navigate = useNavigate()
  const { translations } = useContext(LanguageContext)

  return (
    <aside className='article-cta'>
      <AbstractVisual className='article-cta-visual' shape='loop' colors={['#3b2a9e', '#e7ff02', '#c084fc']} />
      <div className='article-cta-fade' aria-hidden='true' />

      <div className='article-cta-body'>
        <div className='article-cta-text'>
          <p className='article-cta-label'>{translations.articleCtaLabel}</p>
          <h2 className='article-cta-title'>{translations.articleCtaTitle}</h2>
          <p className='article-cta-sub'>{translations.articleCtaSub}</p>
        </div>

        <div className='article-cta-actions'>
          <button className='article-cta-btn' onClick={() => navigate('/contact-us')}>
            {translations.articleCtaPrimary} <span>→</span>
          </button>
          <button className='article-cta-btn article-cta-btn-ghost' onClick={() => navigate('/ai-readiness')}>
            {translations.articleCtaSecondary}
          </button>
        </div>
      </div>
    </aside>
  )
}

export default ArticleCta
